export default 'On vous aide à réduire vos factures d\'énergie et à financer vos travaux. Particulier, pro, entreprise, collectivité, agriculteur : diagnostic gratuit en 60 secondes, réponse chiffrée immédiate.';
